import styled from "@emotion/styled";
import clsx from "clsx";
import { useField } from "formik";
import { useState } from "react";

import { generateUniqueId, mergeProps, useThemeProps } from "../../wsui/base";

import formFieldContext from "./formFieldContext";

const FormFieldWrapperRoot = styled("div")``;

export default function FormFieldWrapper(props) {
  // props = useThemeProps({ props, name: "FormField" });
  let {
    children,
    controlProps,
    description,
    descriptionProps,
    errorProps,
    hideLabel = false,
    id,
    label,
    labelProps,
    multiple,
    name,
    required,
    type,
    value,
    wrapperProps,
    className,
    ...restProps
  } = props;

  let [defaultId] = useState(() => `form-field-${generateUniqueId()}`);
  id = id ?? defaultId;

  const [inputProps, meta, helpers] = useField({ name, multiple, type, value });

  wrapperProps = useThemeProps({
    props: wrapperProps,
    name: "FormFieldWrapper",
  });

  const ownerState = mergeProps(
    {
      controlProps: {
        required,
        "aria-required": required,
        "aria-invalid": !!(meta.touched && meta.error),
        // We use clsx here to make a space-separated list of references
        "aria-describedby": clsx(
          description && `${id}-description`,
          `${id}-errors`,
        ),
      },
    },
    {
      controlProps,
      description,
      descriptionProps,
      errorProps,
      helpers,
      hideLabel,
      id,
      inputProps,
      label,
      labelProps,
      meta,
      multiple,
      name,
      required,
      type,
      wrapperProps,
      ...restProps,
    },
  );

  return (
    <FormFieldWrapperRoot
      className={className}
      ownerState={ownerState}
      {...wrapperProps}
    >
      <formFieldContext.Provider value={ownerState}>
        {children(ownerState)}
      </formFieldContext.Provider>
    </FormFieldWrapperRoot>
  );
}
